import Snackbar from "@material-ui/core/Snackbar";
import PropTypes from "prop-types";
import React from "react";

import {
  DEFAULT_TOAST_POSITION,
  TOAST_POSITION,
} from "../../utils/constants/ToastConstants";

// Toast to show Dismissable Alerts
const Toast = ({
  show = false,
  containerProps = {},
  _alertProps = {},
  _type,
  message,
  position = DEFAULT_TOAST_POSITION,
}) => {
  return (
    show && (
      <Snackbar
        open={show}
        anchorOrigin={TOAST_POSITION[position]}
        {...containerProps}
      >
        <div>{message}</div>
      </Snackbar>
    )
  );
};

export default Toast;

Toast.propTypes = {
  show: PropTypes.bool,
  containerProps: PropTypes.object,
  alertProps: PropTypes.object,
  type: PropTypes.string,
  message: PropTypes.string,
  position: PropTypes.string,
};
